export default __webpack_public_path__ + "static/media/image2.c4711f95.png";